// src/pages/Public/LandingPage/v2/data/landingContent.js
//
// Estructura de datos de la landing. Los TEXTOS traducibles se referencian por clave i18n
// (ver v2/i18n/landingStrings.js) para poder mostrarlos en ES/EN/FR. Lo estable
// (imageKey, letra del pilar, colores, nombres propios de partners/clientes) NO se traduce.

export const LANDING_SECTIONS = [
  { id: "que-es", label: "¿Qué es?", tKey: "whatIs" },
  { id: "terapias", label: "Terapias", tKey: "therapies" },
  { id: "herramientas", label: "Validación", tKey: "validation" },
  { id: "pilares", label: "Pilares", tKey: "pillars" },
];

export const LANDING_ASSET_KEYS = {
  navLogo: "navLogo",
  brandIdentity: "brandIdentity",
  heroImage: "heroImage",
  backgroundVideo: "backgroundVideo",
  creationPanel: "creationPanel",
  clinicalAnalytics: "clinicalAnalytics",

  therapy_cognitive: "therapy_cognitive",
  therapy_reminiscence: "therapy_reminiscence",
  therapy_motor: "therapy_motor",
  therapy_psychosocial: "therapy_psychosocial",
  therapy_expressive: "therapy_expressive",
  therapy_relaxation: "therapy_relaxation",

  logo_upo: "logo_upo",
  logo_ual: "logo_ual",
  logo_sjd: "logo_sjd",
  logo_urjc: "logo_urjc",
};

// Terapias: el icono se elige por imageKey (estable), NO por el titulo (que se traduce).
export const THERAPY_MODULES = [
  {
    titleKey: "therapy1Title",
    descKey: "therapy1Desc",
    imageKey: LANDING_ASSET_KEYS.therapy_cognitive,
    accent: "sky",
  },
  {
    titleKey: "therapy2Title",
    descKey: "therapy2Desc",
    imageKey: LANDING_ASSET_KEYS.therapy_reminiscence,
    accent: "blue",
  },
  {
    titleKey: "therapy3Title",
    descKey: "therapy3Desc",
    imageKey: LANDING_ASSET_KEYS.therapy_motor,
    accent: "indigo",
  },
  {
    titleKey: "therapy4Title",
    descKey: "therapy4Desc",
    imageKey: LANDING_ASSET_KEYS.therapy_psychosocial,
    accent: "cyan",
  },
  {
    titleKey: "therapy5Title",
    descKey: "therapy5Desc",
    imageKey: LANDING_ASSET_KEYS.therapy_expressive,
    accent: "teal",
  },
  {
    titleKey: "therapy6Title",
    descKey: "therapy6Desc",
    imageKey: LANDING_ASSET_KEYS.therapy_relaxation,
    accent: "emerald",
  },
];

// Partners: name/lab son nombres propios (no se traducen); solo el rol se traduce.
export const ACADEMIC_PARTNERS = [
  {
    name: "Univ. Pablo de Olavide",
    roleKey: "partner1Role",
    lab: "Cátedra EDUEMER",
    logoKey: LANDING_ASSET_KEYS.logo_upo,
  },
  {
    name: "Universidad de Almería",
    roleKey: "partner2Role",
    lab: "Centro CiBiS",
    logoKey: LANDING_ASSET_KEYS.logo_ual,
  },
  {
    name: "Orden San Juan de Dios",
    roleKey: "partner3Role",
    lab: "Hospitalaria",
    logoKey: LANDING_ASSET_KEYS.logo_sjd,
  },
  {
    name: "Univ. Rey Juan Carlos",
    roleKey: "partner4Role",
    lab: "Ciencias de la educación, del deporte y estudios interdisciplinares.",
    logoKey: LANDING_ASSET_KEYS.logo_urjc,
  },
];

// Pilares (R-E-V-I). `letter` es el valor ESTABLE (elige icono y no cambia); el texto
// mostrado de la letra viene de `letterKey` (en FR la E lleva tilde: "É").
export const PILLARS = [
  {
    letter: "R",
    letterKey: "pillar1L",
    titleKey: "pillar1Title",
    descKey: "pillar1Desc",
    tone: "sky",
    color: "from-sky-400 to-sky-500",
    letterColor: "text-sky-400",
  },
  {
    letter: "E",
    letterKey: "pillar2L",
    titleKey: "pillar2Title",
    descKey: "pillar2Desc",
    tone: "blue",
    color: "from-blue-400 to-blue-500",
    letterColor: "text-sky-500",
  },
  {
    letter: "V",
    letterKey: "pillar3L",
    titleKey: "pillar3Title",
    descKey: "pillar3Desc",
    tone: "indigo",
    color: "from-sky-500 to-blue-500",
    letterColor: "text-blue-500",
  },
  {
    letter: "I",
    letterKey: "pillar4L",
    titleKey: "pillar4Title",
    descKey: "pillar4Desc",
    tone: "teal",
    color: "from-blue-500 to-indigo-500",
    letterColor: "text-blue-600",
  },
];

// Clientes: nombres propios (no se traducen).
export const CLIENTS = [
  { name: "Residencia San Juan de Dios (Sevilla)", logoKey: "client_sjd" },
  { name: "Residencia Virgen de Veladíez (Segovia)", logoKey: null },
  { name: "Residencia Nuestra Señora de Cortes (Albacete)", logoKey: null },
  { name: "Residencia Altavida (Murcia)", logoKey: "client_altavida" },
  { name: "Residencia Nuevo Azahar (Murcia)", logoKey: null },
  { name: "Residencia María de la Paz (Huelva)", logoKey: null },
  { name: "ASPROSUB Virgen de la Vega (Zamora)", logoKey: "client_asprosub" },
  { name: "Fundación Diagrama", logoKey: "client_diagrama" },
  { name: "Aula Abierta de Mayores (UPO)", logoKey: "logo_upo" },
];
